import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Skeleton as AbyssSkeleton } from '@uhg-abyss/web/ui/Skeleton';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * Skeleton
 *
 * Displays a roughed-in idea/placeholder of what the UI should look like while the data is fetching from the API.
 *
 * @returns {Element}
 * @constructor
 */
export function Skeleton() {
  return (
    <ErrorHandler location="src/pages/private/ActionPaths/View/layouts/Header/components/Skeleton/Skeleton.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid>
          <Grid.Col
            css={{ paddingRight: 0 }}
            span={{
              xs: '100%',
            }}
          >
            <Layout.Stack alignItems="left" grow>
              <AbyssSkeleton height={themeConfiguration?.theme?.space?.xl} width="50%" />
              <AbyssSkeleton height={themeConfiguration?.theme?.space?.lg} width="30%" />
            </Layout.Stack>
          </Grid.Col>
        </Grid>
        <Divider color="transparent" />
      </motion.div>
    </ErrorHandler>
  );
}
